import React from "react";
import Select from "react-select";
import {PlatformIconProvider} from "../../providers/icons/PlatformIconProvider";

export class SelectPlatformWithIcon extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value
        }

        this.reset = this.reset.bind(this);
    }

    onChange = (e) => {
        this.props.onChange(e);
        this.setState({value: e.value});
    }

    reset() {
        this.setState({value: ''});
    }

    render() {
        const options = PlatformIconProvider.getIconData();
        let selectedItem;
        if (this.state.value) {
            selectedItem = PlatformIconProvider.getIconItem(this.state.value)
        }

        if (selectedItem) {
            return (
                <Select
                    value={selectedItem}
                    options={options}
                    placeholder="Selecciona una plataforma"
                    isDisabled={this.props.disabled}
                    onChange={this.onChange}
                />
            );
        } else {
            return (
                <Select
                    value={'Selecciona una plataforma'}
                    options={options}
                    placeholder="Selecciona una plataforma"
                    isDisabled={this.props.disabled}
                    onChange={this.onChange}
                />
            );
        }
    }
}